import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useComparison } from '../context/ComparisonContext';
import { formatCurrency } from '../utils/formatters';
import { X } from 'lucide-react';
import './ComparisonTray.css';

const ComparisonTray = () => {
    const { compareList, compareCount, removeFromCompare } = useComparison();
    const navigate = useNavigate();
    const [isDismissed, setIsDismissed] = useState(false);

    // Auto-show when items are added
    useEffect(() => {
        if (compareCount > 0) {
            setIsDismissed(false);
        }
    }, [compareCount]);

    if (compareCount === 0 || isDismissed) return null;

    const handleAction = () => {
        if (compareCount === 1) {
            navigate(`/scenarios/${compareList[0].property_id}`);
        } else {
            navigate('/compare');
        }
    };

    return (
        <div className="comparison-tray">
            <div className="comparison-tray-inner">
                <div className="comparison-tray-label">
                    <span className="selected-pill">Selected</span>
                    <span className="selected-count">{compareCount}</span>
                </div>

                <div className="comparison-tray-cards">
                    {compareList.map((prop) => (
                        <div key={prop.property_id} className="tray-mini-card">
                            <div className="tray-mini-photo">
                                {prop.primary_photo_url ? (
                                    <img src={prop.primary_photo_url} alt="" />
                                ) : (
                                    <div className="tray-mini-photo-placeholder" />
                                )}
                            </div>
                            <div className="tray-mini-info">
                                <span className="tray-mini-price">{formatCurrency(prop.list_price)}</span>
                                <span className="tray-mini-address">{prop.address}</span>
                            </div>
                            <button
                                className="tray-mini-remove"
                                onClick={() => removeFromCompare(prop.property_id)}
                                aria-label="Remove from comparison"
                            >
                                <X size={14} />
                            </button>
                        </div>
                    ))}
                </div>

                <button className="comparison-tray-action" onClick={handleAction}>
                    {compareCount === 1 ? 'Run Single Property Analysis' : 'Compare Multiple Properties'}
                </button>

                <button
                    className="comparison-tray-close"
                    onClick={() => setIsDismissed(true)}
                    aria-label="Dismiss tray"
                >
                    <X size={18} />
                </button>
            </div>
        </div>
    );
};

export default ComparisonTray;
